import React from 'react';
import logo from '../img/aesoslight.png'


const Footer = () => {
  return (
    <div className="container-fluid footer bg-dark wow fadeIn" data-wow-delay=".3s">
      <div className="container pt-5 pb-4">
        <div className="row g-5">
          {/* Logo and description */}
          <div className="col-lg-3 col-md-6">
            <a href="/">
              {/* <h1 className="text-white fw-bold d-block">
                A<span className="text-secondary">esos</span>
              </h1> */}
              <img src={logo} width={150}  style={{borderRadius:'4px'}}/>
            </a>
            <p className="mt-4 text-light">
              AESOS is dedicated to bridging the gap between academia and industry. We provide students with hands-on training, real projects, and mentorship to ensure they are job-ready. Our mission is to empower the next generation of engineers to excel in the workplace.
            </p>
            <div className="d-flex hightech-link">
              <a href="https://www.facebook.com/share/18zqF6LFrB/" className="btn-light nav-fill btn btn-square rounded-circle me-2">
                <i className="fab fa-facebook-f text-primary"></i>
              </a>
              {/* <a href="https://x.com/theaesos?t=5yWEntt8ganZ2O559AjBEw&s=09" className="btn-light nav-fill btn btn-square rounded-circle me-2">
                <i className="fab fa-twitter text-primary"></i>
              </a> */}
              <a href="https://www.instagram.com/aesos.in?igsh=cnhybHBrZDRibXVk" className="btn-light nav-fill btn btn-square rounded-circle me-2">
                <i className="fab fa-instagram text-primary"></i>
              </a>
              <a href="https://www.linkedin.com/company/aesos/?viewAsMember=true" className="btn-light nav-fill btn btn-square rounded-circle me-0">
                <i className="fab fa-linkedin-in text-primary"></i>
              </a>
            </div>
          </div>

          {/* Short Links */}
          <div className="col-lg-3 col-md-6">
            <h3 className="text-secondary">Short Link</h3>
            <div className="mt-4 d-flex flex-column short-link">
              <a href="/about" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>About us</a>
              <a href="/contact" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Contact us</a>
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Our Services</a>
              <a href="/projects" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Our Projects</a>
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Latest Blog</a>
            </div>
          </div>

          {/* Help Links */}
          <div className="col-lg-3 col-md-6">
            <h3 className="text-secondary">Help Link</h3>
            <div className="mt-4 d-flex flex-column help-link">
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Terms Of use</a>
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Privacy Policy</a>
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Helps</a>
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>FQAs</a>
              <a href="#" className="mb-2 text-white"><i className="fas fa-angle-right text-secondary me-2"></i>Contact</a>
            </div>
          </div>

          {/* Contact Details */}
          <div className="col-lg-3 col-md-6">
            <h3 className="text-secondary">Contact Us</h3>
            <div className="text-white mt-4 d-flex flex-column contact-link">
              <a href="#" className="pb-3 text-light border-bottom border-primary">
                <i className="fas fa-map-marker-alt text-secondary me-2"></i> Mohali, Punjab, India
              </a>
              <a href="tel:+919277005656" className="py-3 text-light border-bottom border-primary">
                <i className="fas fa-phone-alt text-secondary me-2"></i> +919277005656
              </a>
              <a href="mailto:info@aesos.in" className="py-3 text-light border-bottom border-primary">
                <i className="fas fa-envelope text-secondary me-2"></i> info@aesos.in
              </a>
            </div>
          </div>
        </div>

        <hr className="text-light mt-5 mb-4" />

        <div className="row">
          <div className="col-md-6 text-center text-md-start">
            <span className="text-light">
              <a href="#" className="text-secondary">
                <i className="fas fa-copyright text-secondary me-2"></i>Aesos
              </a>
              , All right reserved.
            </span>
          </div>
          <div className="col-md-6 text-center text-md-end">
            <span className="text-light">
              Designed By
              <a href="https://directclick.netlify.app/" className="text-secondary"> Aesos</a>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
